export const isProd = process.env.VUE_APP_ENV.toString() === "main";
export const isCdt = process.env.VUE_APP_ENV.toString() === "cdt";

console.log("process.env.VUE_APP_ENV =", process.env.VUE_APP_ENV);
console.log("isProd =", isProd);
console.log("isCdt =", isCdt);
console.log("Value:", process.env.VUE_APP_ENV);
console.log("Type:", typeof process.env.VUE_APP_ENV);
console.log("Length:", process.env.VUE_APP_ENV.length);
console.log("JSON:", JSON.stringify(process.env.VUE_APP_ENV));
console.log("Equals:", process.env.VUE_APP_ENV === "main");

export const API_SCOPE =
  process.env.VUE_APP_ENV === "main"
    ? "api://9e0b4dc8-2723-4ca9-82c1-e39a895019bf/ReadWrite"
    : process.env.VUE_APP_ENV === "cdt"
      ? "api://03c509be-edbb-4d3a-a066-3122afd6acf8/ReadWrite"
      : "api://03c509be-edbb-4d3a-a066-3122afd6acf8/ReadWrite";

export const LOGIN_REQUEST_SCOPES = {
  scopes: ["User.Read"],
  extraScopesToConsent: [API_SCOPE]
};

export const AV_REQUEST_SCOPES = {
  scopes: [API_SCOPE]
};

export const SILENT_TOKEN_REFRESH_SCOPES = (currentAccount) => ({
  scopes: ["User.Read"],
  account: currentAccount,
  forceRefresh: false
});

export const AV_SILENT_TOKEN_REFRESH_SCOPES = (currentAccount) => ({
  scopes: [API_SCOPE],
  account: currentAccount,
  forceRefresh: false
});

export const Tenant = "05d75c05-fa1a-42e7-9cf1-eb416c396f2d";

export const CLIENT_ID =
  process.env.VUE_APP_ENV === "main"
    ? "9e0b4dc8-2723-4ca9-82c1-e39a895019bf"
    : process.env.VUE_APP_ENV === "cdt"
      ? "03c509be-edbb-4d3a-a066-3122afd6acf8"
      : "03c509be-edbb-4d3a-a066-3122afd6acf8";

export const Redirect_Uri =
   process.env.VUE_APP_ENV === "main"
    ? "https://generic-evms-bowlerchart.prod.maersk.io/"
    : process.env.VUE_APP_ENV === "cdt"
      ? "https://generic-evms-bowlerchart.nonprod.maersk.io/"
      : "http://localhost:8081/";

export const Graph_Api_Base = "https://graph.windows.net";

export const Graph_Api_Resource = "00000002-0000-0000-c000-000000000000";

export const Msal_Config = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${Tenant}/`,
    requireAuthOnInitialize: true,
    autoRefreshToken: true,
    redirectUri: Redirect_Uri,
    postLogoutRedirectUri: Redirect_Uri
  },
  request: {
    scopes: ["User.Read"]
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  },
  graph: {
    callAfterInit: false
  }
};

